/** Links externos do site institucional — fonte única para evitar divergência. */
export const DISCORD_INVITE_URL = 'https://discord.gg/qnZc8sJEWW';
export const CONTACT_EMAIL = 'contato.livinpixel@gmail.com';

/** Matéria do O Canal sobre o LivinPixel (setembro 2026). */
export const OCANAL_LIVINPIXEL_ARTICLE_URL =
  'https://ocanal.com/adeus-vida-real-novo-jogo-brasileiro-cria-mundo-onde-voce-pode-ser-praticamente-quem-quiser/';

/** Post do LivinPixel no Product Hunt — link discreto no rodapé, sem embed. */
export const PRODUCT_HUNT_URL =
  'https://www.producthunt.com/products/livinpixel?embed=true&utm_source=embed&utm_medium=post_embed';
